import React from 'react';
import styles from './Hero.module.css';

const Hero = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.heroContent}>
        <h1 className={styles.name}>Justin Hynes</h1>
        <p className={styles.title}>Full stack-ish Developer</p>
        <p className={styles.tagline}>A collaborative engineer with a strong track record supporting and mentoring small teams.</p>
      </div>
    </section>
  );
};

export default Hero;
